export default "<section>\n  <ngb-rating [(rate)]=\"currentRate\"></ngb-rating>\n  <hr />\n  <pre>Rate: <strong>{{currentRate}}</strong></pre>\n</section>\n";